import React from "react";
import {
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
    Grid,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Chip,
    Typography,
} from "@material-ui/core";
import { useStyles, StyledTableCell } from "../../adminStyles";

const NotesDialogue = props => {
    const {
        dialogTitleContainer,
        dialogTitle,
        chip,
        chipLabel,
        btn,
        noDataMessage,
    } = useStyles();

    const {
        detailOpen,
        selectedUser,
        notesObj,
        handleDetailClose
    } = props;


    const renderStyledTableCell = () =>
        <StyledTableCell align={"center"} padding={"default"}>
        {"Notes"}
    </StyledTableCell>
            

    const renderTableBody = () => {
        return notesObj &&
        notesObj.length === 0 ? (
            <h2 className={noDataMessage}>No Data</h2>
        ) : (
            notesObj.map(day => {
                    return (
                        <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={Math.random()}
                        >
                                    <TableCell
                                    >{day.note}
                                    </TableCell>
                        </TableRow>
                    );
                })
        );
    };

    return (
        <Dialog
            open={detailOpen}
            onClose={handleDetailClose}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle
                id="form-dialog-title"
                className={dialogTitleContainer}
            >
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="center"
                >
                    <Grid item xs={12} sm={6}>
                        <Typography variant="h5" className={dialogTitle}>
                            {selectedUser}
                        </Typography>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={6}
                        container
                        direction="row"
                        justify="center"
                        alignItems="center"
                        style={{
                            flexWrap: "nowrap",
                        }}
                    >
        
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent style={{ padding: 0 }}>
                <Table>
                    <TableHead>
                        <TableRow>{renderStyledTableCell()}</TableRow>
                    </TableHead>
                    <TableBody>
                        {!notesObj ? (
                            <div>loading</div>
                        ) : (
                            renderTableBody()
                        )}
                    </TableBody>
                </Table>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button
                    onClick={handleDetailClose}
                    color="primary"
                    className={btn}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default NotesDialogue;
